module.exports = require("html-webpack-plugin");